/* import __COLOCATED_TEMPLATE__ from './site-content.hbs'; */
import { tagName } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';

@classic
@tagName('main')
export default class SiteContent extends Component {}
